import React from "react";
import { icons } from "@a365/dsys";
import { useIsMobile, useBreakpointDown } from "@a365/core";

const { ShieldCheck } = icons;

const BannerCard3 = ({ bannerData }) => {
  const isMobile = useIsMobile();
  const isMD = useBreakpointDown("md");

  return (
    <div
      className="
      rounded-2xl
  bg-brand-comp-lightblue p-4 xl:p-6 xl:py-8 flex items-start justify-end text-text-default text-2xl xl:text-4xl font-semibold
      relative z-10 text-wrap w-full xl:w-[384px] xl:min-w-[384px] xl:h-[280px]
    xl:items-start xl:justify-center flex-row xl:flex-col space-y-1"
    >
      <ShieldCheck
        size={isMobile && isMD ? 32 : 48}
        weight="duotone"
        className="text-icon-darker xl:mb-14 mr-3 xl:mr-3"
      />
      {bannerData?.slide_2?.left?.text}
    </div>
  );
};

export default BannerCard3;
